import { zodResolver } from '@hookform/resolvers/zod'
import { Box, Grid } from '@mui/material'
import { useCallback, useContext, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useSubmitOperacion } from '../../hooks/useSubmitOperacion'
import { ContextOperacionNuevo, ContextOperacionNuevoType } from '../../NuevoSistema'
import { HttpADL } from './api/httpADL'
import { OperacionADLInsert, schemaOperacionADLInsert } from './types/dto'
import { OperacionADLFields } from './types/fields'
import { SeccionNuevoADLDatosOperacion } from './components/SeccionNuevoADLDatosOperacion'
import { SeccionNuevoADLDetalleTransaccion } from './components/SeccionNuevoADLDetalleTransaccion'
import SeccionNuevoArchivo from '../../components/SeccionNuevoArchivo'

interface NuevoSistemaADLProps {
  codSistemaPrincipal: number
}

const NuevoSistemaADL = ({ codSistemaPrincipal }: NuevoSistemaADLProps) => {
  const { submitOperacion } = useSubmitOperacion();

  const formMethods = useForm<OperacionADLInsert>({
    resolver: zodResolver(schemaOperacionADLInsert),
    defaultValues: {
      [OperacionADLFields.FechaSolicitud]: new Date(),
      [OperacionADLFields.CodPais]: codSistemaPrincipal,

      [OperacionADLFields.NroCuenta]: '',
    }
  })



  const handleCrearOperacion = useCallback(
    (data: OperacionADLInsert) => {
      submitOperacion(data, {
        apiCall: HttpADL.post,
        codSistemaPrincipal,
      });
    },
    [codSistemaPrincipal, submitOperacion]
  );

  const { setSavePromise, setSendPromise, codSistema } = useContext<ContextOperacionNuevoType>(ContextOperacionNuevo)

  useEffect(() => {
    setSendPromise(() => formMethods.handleSubmit(handleCrearOperacion))
  }, [formMethods, handleCrearOperacion, setSavePromise, setSendPromise])


  return (
    <Box>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <SeccionNuevoADLDatosOperacion formMethods={formMethods} codSistema={codSistema} codPais={codSistemaPrincipal} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoADLDetalleTransaccion formMethods={formMethods} />
        </Grid>
        <Grid item xs={12}>
          <SeccionNuevoArchivo formMethods={formMethods} />
        </Grid>
      </Grid>
    </Box>
  )
}

export default NuevoSistemaADL
